<template>
    <vue-qr v-if="format == 'qr'" v-bind="options" />
    <img v-else :id="id">
</template>
<script>
import JsBarcode from 'jsbarcode'
import VueQr from "vue-qr";
export default {
    name:'l-barcode',
    components: {
        VueQr
    },
    props: {
        value: String,
        format: {
            type: String,
            default: "CODE128"
        },
        width: {
            type: Number,
            default: 2
        },
        height: {
            type: Number,
            default: 100
        },
        displayValue: {
            type: Boolean,
            default: true
        },
        text: String,
        fontOptions: {
            type: String,
            default: ""
        },
        font: {
            type: String,
            default: "monospace"
        },
        textAlign: {
            type: String,
            default: "center"
        },
        textPosition: {
            type: String,
            default: "bottom"
        },
        textMargin: {
            type: Number,
            default: 2
        },
        fontSize: {
            type: Number,
            default: 20
        },
        background: String,
        color: {
            type: String,
            default: "#000000"
        },
        margin: {
            type: Number,
            default: 0
        },
        marginTop: Number,
        marginRight: Number,
        marginBottom: Number,
        marginLeft: Number,
        flat: {
            type: Boolean,
            default: !1
        },
        size: {
            type: Number,
            default: 400
        },
        correctLevel: {
            type: Number,
            default: 0
        },
        autoColor: {
            type: Boolean,
            default: !0
        },
        backgroundImage: String,
        backgroundDimming: String,
        gifBackground: String,
        whiteMargin: {
            type: Boolean,
            default: true
        },
        logoImage: String,
        logoScale: {
            type: Number,
            default: .2
        },
        logoMargin: {
            type: Number,
            default: 6
        },
        logoCornerRadius: {
            type: Number,
            default: 8
        }
    },
    data () {
        return {
            id: 'aaa',
            qrUrl: ""
        }
    },
    watch: {
        value:{
            handler(){
                this.showCode()
            },
            immediate: true
        },
        options () {
            if (this.value) this.showCode()
        }
    },
    created() {
        this.id = 'id_' + this.$uuid()
        console.log(this.id, 'this.id----')
    },
    computed:{
        options: function() {
            var e = {};
            return "qr" == this.format ? (e.text = this.value,
            e.size = this.size,
            e.margin = this.margin,
            e.correctLevel = this.correctLevel,
            e.colorDark = this.color,
            e.colorLight = this.background,
            e.autoColor = this.autoColor,
            e.bgSrc = this.backgroundImage,
            e.backgroundDimming = this.backgroundDimming,
            e.gifBgSrc = this.gifBackground,
            e.whiteMargin = this.whiteMargin,
            e.logoSrc = this.logoImage,
            e.logoScale = this.logoScale,
            e.logoMargin = this.logoMargin,
            e.logoCornerRadius = this.logoCornerRadius) : (e.format = this.format,
            e.width = this.width,
            e.height = this.height,
            e.text = this.value,
            e.fontOptions = this.fontOptions,
            e.textAlign = this.textAlign,
            e.textPosition = this.textPosition,
            e.textMargin = this.textMargin,
            e.fontSize = this.fontSize,
            e.background = this.background,
            e.lineColor = this.color,
            e.margin = this.margin,
            e.marginTop = this.marginTop,
            e.marginRight = this.marginRight,
            e.marginBottom = this.marginBottom,
            e.marginLeft = this.marginLeft,
            e.displayValue = this.displayValue,
            e.flat = this.flat),
            e
        }
    },
    methods:{
        showCode: function() {
            console.log(this.id, 'this.id----')
            if ("qr" != this.format) {
                setTimeout(() => {
                    JsBarcode(`#${this.id}`, this.options.text, this.options)
                    console.log(this.options, 'this.options----')
                    console.log(this.options.text, 'this.options.text----')
                }, 200);
                
            }
                
        }
    }
}
</script>